import { Icon } from "@iconify/react";
function ModalConfig(props) {
  const { idbox, width, height,bgcolor, title, idclose, content } = props;
  
  // console.log("props in modalconfig >>>",idbox,width,height)
  return (
    <div className="modalConfig-contentbox" id={idbox}>
      <div
        className="modalConfig-contentbody"
        style={{ width: width, height: height ,backgroundColor:bgcolor}}
      >
        <div className="content-body-modalConfig">{content}</div>
      </div>
    </div>
  );
}
export default ModalConfig;
